import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

const getUrlPath = encodedTerm => `${apiUtils.getBaseUri()}/search/autocomplete/${encodedTerm}`;

const getPopularSuggestionsUrl = maxPopularSearches =>
    `${apiUtils.getBaseUri()}/search/popularTerms?maxResults=${maxPopularSearches}`;

const getSearchResults = async (term, componentUid) => {
    // term should NOT be encoded previously
    const encodedTerm = encodeURIComponent(term);

    const url = new URL(getUrlPath(encodedTerm), window.origin);

    url.searchParams.append('config', componentUid);

    const response = await HTTPClient().get(url.toString(), {}, true);
    if (!response.ok) {
        throw new Error(`Unable to load search (${response.status})`);
    }
    return await response.json();
};

const getSearchFilteredResults = async uri => {
    const response = await HTTPClient().get(uri, {}, true);
    if (!response.ok) {
        throw new Error(`Unable to load search (${response.status})`);
    }
    return await response.text();
};

const getSearchResultsCounter = async (term, type) => {
    const url = `/search/results?q=${term}&type=${type}`;
    const response = await HTTPClient().head(url);
    if (!response.ok) {
        throw new Error(`Unable to load search result counters (${response.status})`);
    }
    return +response.headers.get('X-Total-Count');
};

const getPopularSuggestions = async maxPopularSearches => {
    const url = new URL(getPopularSuggestionsUrl(maxPopularSearches), window.origin);
    const response = await HTTPClient().get(url.toString(), {}, true);

    if (!response.ok) {
        throw new Error(`Unable to load search (${response.status})`);
    }
    return await response.json();
};

const getSearchProduct = async (source, term = '', currentPage = 0) => {
    const url = `${apiUtils.getBaseUri()}/products/search?query=${term}${
        typeof source === 'string' && source !== '' ? `&fields=${source}` : ''
    }${typeof currentPage === 'number' ? `&currentPage=${currentPage}` : ''}`;
    const response = await HTTPClient().get(url);
    if (!response.ok) {
        throw new Error(`Unable to load product search result (${response.status})`);
    }
    return await response.json();
};

export default {
    getSearchResults,
    getSearchFilteredResults,
    getSearchResultsCounter,
    getPopularSuggestions,
    getSearchProduct,
};
